import script from "./ClaimPrize.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimPrize.vue?vue&type=script&setup=true&lang=js"

import "./ClaimPrize.vue?vue&type=style&index=0&id=f8b9572e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8b9572e"]])

export default __exports__